export default "__VITE_ASSET__ff3ffda5__"